require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;


//////////////////
// WEBPACK FOOTER
// ./~/@deskproapps/dpat/~/core-js/library/fn/object/assign.js
// module id = RTjf
// module chunks = 0